// ============================================================
// Stream N — HTTP-клиент сайта.
// Авторизация через httpOnly cookie (credentials: 'include').
// Дополнительно храним Bearer-токен в localStorage на случай cross-site,
// когда браузер блокирует сторонние cookie.
// ============================================================

export const API_BASE: string =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';

const TOKEN_KEY = 'apw.session.token';

export function getStoredToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}
export function setStoredToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
    this.name = 'ApiError';
  }
}

export function authHeader(): Record<string, string> {
  const token = getStoredToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const headers: Record<string, string> = {
    ...authHeader(),
    ...(options?.headers as Record<string, string> | undefined),
  };
  if (options?.body != null && headers['Content-Type'] == null) {
    headers['Content-Type'] = 'application/json';
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    credentials: 'include',
  });

  if (res.status === 401) {
    // Сессия протухла — чистим токен и сигналим наверх.
    setStoredToken(null);
    window.dispatchEvent(new CustomEvent('apw:unauthorized'));
    throw new ApiError(401, 'Unauthorized');
  }
  if (!res.ok) {
    const txt = await res.text().catch(() => res.statusText);
    throw new ApiError(res.status, `API ${res.status}: ${txt}`);
  }
  if (res.status === 204) return undefined as unknown as T;
  const ct = res.headers.get('content-type') ?? '';
  if (!ct.includes('application/json')) return undefined as unknown as T;
  return res.json() as Promise<T>;
}
